import React from 'react'
import Layout from '../components/Layout'
import { GlobeAltIcon } from '@heroicons/react/24/outline'

const PublicPortal: React.FC = () => {
  return (
    <Layout portalType="public">
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">Public Transparency Portal</h1>
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <GlobeAltIcon className="h-12 w-12 text-green-600 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Public Dashboard</h3>
            <p className="text-gray-600">Access anonymized recycling data and educational content.</p>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="font-medium text-green-900">Public Dashboard</h4>
                <p className="text-sm text-green-700 mt-1">View aggregated recycling statistics</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="font-medium text-green-900">Educational Content</h4>
                <p className="text-sm text-green-700 mt-1">Learn about recycling and sustainability</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="font-medium text-green-900">Transparency Reports</h4>
                <p className="text-sm text-green-700 mt-1">Access public transparency reports</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default PublicPortal
